/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { AddressDto } from '../../../../../apps/myprofile-ui/src/app/services/address/address.service'
import { HttpHeaders } from '@angular/common/http'

export class SetEditorLoadingStatus {
  static readonly type = '[address-editor] set editor loading status'

  constructor(public loading: boolean) {}
}

export class ShowBlankEditor {
  static readonly type = '[address-editor] show blank editor'

  constructor(
    public visible: boolean,
    public instanceId: string,
  ) {}
}

export class CreateAddress {
  static readonly type = '[address-editor] create address'

  constructor(
    public address: AddressDto,
    public instanceId: string,
    public headers?: HttpHeaders,
  ) {}
}

export class UpdateAddress {
  static readonly type = '[address-editor] update address'

  constructor(
    public address: AddressDto,
    public instanceId: string,
    public headers?: HttpHeaders,
  ) {}
}

export class DeleteAddress {
  static readonly type = '[address-editor] delete address'

  constructor(
    public addressId: string,
    public instanceId: string,
    public headers?: HttpHeaders,
  ) {}
}

export class GetSchemas {
  static readonly type = '[address-editor] get schemas'
}

export class AddSchemaForCountry {
  static readonly type = '[address-editor] add schema for country'

  constructor(public country: string) {}
}

export class SetEditorSchema {
  static readonly type = '[address-editor] set editor schema'

  constructor(
    public country: string,
    public instanceId: string,
  ) {}
}

export class UpdateTmpAddress {
  static readonly type = '[address-editor] update tmp address'

  constructor(
    public tempAddress: AddressDto,
    public instanceId: string,
  ) {}
}
